<template>
    <div id="filters_group" class="flex flex-column justify-content-between align-items-center main_search_slider">
        <form class="main__search" :action="currentSearch">
            <div class="gs:grid relative z-9 filters-form-container" >
                <div class="md:col-1/5 form-group form-group-filter">
                    <label class="form-label tx-gray-ad" for="brands_select">
                        Marca
                    </label>
                    <v-select
                        @click.native="loadBrands()"
                        v-model="filters.brands"
                        :reduce="brands => brands.value"
                        :options="getBrands()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input-filter"
                        name="brands"
                        id="brands_select"
                    >
                        <span slot="no-options">
                            {{
                                brandsLoads && !getBrands()
                                    ? "Sin resultados"
                                    : "Cargando..."
                            }}
                        </span>
                    </v-select>
                </div>
                <div class="md:col-1/5 form-group form-group-filter">
                    <label class="form-label tx-gray-ad" for="models_select">
                        Modelo
                    </label>
                    <v-select
                        v-model="filters.models"
                        :reduce="models => models.value"
                        :options="getModels()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input-filter"
                        name="models"
                        id="models_select"
                    >
                        <span slot="no-options">{{
                            modelsLoads && !getBrands()
                                ? "Sin resultados"
                                : "Seleccione una marca para continuar..."
                        }}</span>
                    </v-select>
                </div>
                <div class="md:col-1/5 form-group form-group-filter">
                    <price-filter-input-component
                        @price="getPrice"
                        :price="filters.prices.to"
                    ></price-filter-input-component>
                </div>
                <div class="md:col-1/5 form-group form-group-filter">
                    <label class="form-label tx-gray-ad" for="state_select">
                        Estado
                    </label>
                    <v-select
                        @click.native="loadDealershipsStates()"
                        v-model="filters.states"
                        :reduce="states => states.value"
                        :options="getDealershipsStates()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input-filter"
                        name="states"
                        id="state_select"
                    >
                        <span slot="no-options">
                            {{
                                statesLoads && !getDealershipsStates()
                                    ? "Sin resultados"
                                    : "Cargando..."
                            }}
                        </span>
                    </v-select>
                </div>
                <div class="md:col-1/5 form-group form-group-filter">
                    <label class="form-label tx-gray-ad" for="state_select">
                        Agencia
                    </label>
                    <v-select
                        v-model="filters.dealerships"
                        :reduce="dealerships => dealerships.value"
                        :options="getStatesDealerships()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input-filter"
                        name="dealership"
                        id="dealership_select"
                        full-width="true"
                    >
                     <span slot="no-options">{{
                            !filters.states
                                ? "Seleccione una estado para continuar..."
                                : (!getStatesDealerships() ? "Sin resultados" : "")
                            }}
                     </span>
                    </v-select>
                </div>
            </div>
        </form>
        <p id="inventory_count" >+<span>{{inventoryCountFormatted}}</span>
        autos de agencia</p>
        <a :href="currentSearch" id="search_button" class="btn btn--green-ad btn-sell btn--nav-ad py-2">
            {{searchButtonText}}
        </a>
    </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { TheMask } from "vue-the-mask";
Vue.component("v-select", vSelect);

export default {
    props: ["data", "inventory-count"],
    data: () => ({
        statesLoads: false,
        currentSearch: "/catalogo",
        searchButtonText: 'Ver todos los autos',
        filters: {
            brands: null,
            models: null,
            states: null,
            dealerships: null,
            prices: {
                from: null,
                to: null
            },
            zip_code: null
        },
        brandsLoads: false,
        modelsLoads: false,
    }),
    components: {
        TheMask
    },
    watch: {
        filters: {
            handler(newVal) {
                this.setQueryToLocation();
                this.$emit("filters", newVal);

                const isAnyFilterSelected = (Number.isInteger(this.filters.brands)
                || Number.isInteger(this.filters.prices.to)
                || Number.isInteger(this.filters.states))

                this.searchButtonText = isAnyFilterSelected
                ? 'Buscar'
                : 'Ver todos los autos'
            },
            deep: true
        },
        data: {
            handler(value) {
                if (value) {
                    this.filters = value;
                }
            },
            deep: true
        }
    },

    methods: {
        loadBrands() {
            this.filters.models = null;
            this.$store.dispatch("catalog/getBrands");
        },

         loadDealershipsStates() {
            this.filters.dealerships = null
            this.$store.dispatch("catalog/getDealershipsStates")
        },

        getBrands() {
            return _.map(this.$store.state.catalog.brands, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
            this.brandsLoads = true;
        },

        getDealershipsStates() {
            return _.map(this.$store.state.catalog.states, function(item, key) {
                return {
                    name: item.name,
                    value: item.id
                };
            });
            this.statesLoads = true;
        },
        getModels() {
            let vm = this;
            vm.modelsLoads = false;
            let data = _.filter(this.$store.state.catalog.models, function(
                item,
                key
            ) {
                return item.brand_id === vm.filters.brands;
            });

            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
            vm.modelsLoads = true;
        },
        getStatesDealerships() {
            let vm = this;

            let data = _.filter(this.$store.state.catalog.dealerships, function(
                item,
                key
            ) {
                return item.state_id === vm.filters.states;
            })

            return _.map(data, function(item, key) {
                return {
                    name: item.name,
                    value: item.id
                };
            });
        },
        getPrice(value) {
            this.filters.prices.to = value;
        },
        setQueryToLocation() {
            let vm = this;
            let CurrentUrl = window.location.origin + "/catalogo";
            let filters = [];

            if (!!vm.filters["brands"]) {
                filters.push("brands=" + vm.filters["brands"]);
            }
            if (!!vm.filters["models"]) {
                filters.push("models=" + vm.filters["models"]);
            }
            if (!!vm.filters["zip_code"]) {
                filters.push("zip_code=" + vm.filters["zip_code"]);
            }
            if (!!vm.filters["states"]) {
                filters.push("states=" + vm.filters["states"]);
            }
            if (!!vm.filters["dealerships"]) {
                filters.push("dealerships=" + vm.filters["dealerships"]);
            }
            if (
                !!vm.filters["prices"]["from"] ||
                !!vm.filters["prices"]["to"]
            ) {
                filters.push(
                    "prices=from:" +
                        vm.filters["prices"]["from"] +
                        ",to:" +
                        vm.filters["prices"]["to"]
                );
            }
            let urlSearch = _.join(filters, "&")
            vm.currentSearch = CurrentUrl + "?" + urlSearch
        },
        getProducts(event) {
            event.preventDefault();
            window.location.href = this.currentSearch;
        }
    },
    computed: {
        inventoryCountFormatted() {
            return (Intl.NumberFormat('es-MX')).format(this.inventoryCount)
        }
    }
};
</script>

<style lang="scss" scoped>
#dealership_select {
    >.vs__dropdown-menu {
        width: 220px !important;
    }
}

#filters_container {
    width: 100%;
    height: 300px;
    @media only screen and (max-width: 767px) {
        height: 400px !important;
    }
}
#filters_group {
    // position: absolute;
    // transform: translateY(65vh);
    width: 100%;
    height: 220px;

/*     @media only screen and (max-width: 1279px) {
        transform: translateY(27vh);
    }

    @media only screen and (min-width: 1024px) and (max-width: 1278px) {
        transform: translateY(44vh);
    }

    @media only screen and (min-width: 360px) and (max-height: 926px) {
        height: 345px;
      transform: translateY(54vh);
    }
        @media only screen and (min-width: 360px) and (max-height: 844px) {
            height: 345px;
            transform: translateY(44vh);
        }
    @media only screen and (min-width: 360px) and (max-height: 760px) {
        height: 345px;
        transform: translateY(42vh);
    }
    @media only screen and (min-width: 360px) and (max-height: 660px) {
        height: 345px;
        transform: translateY(38vh);
    }
    @media only screen and (min-width: 300px) and (max-height: 900px) {
        height: 345px;
        transform: translateY(38vh);
    }
    @media only screen and (min-width: 300px) and (max-height: 660px) {
        height: 345px;
        transform: translateY(37vh);
    }
    @media only screen and (min-width: 300px) and (max-height: 569px) {
      height: 345px;
      transform: translateY(33vh);
    }
    @media only screen and (min-width: 300px) and (max-height: 470px) {
      height: 345px;
      transform: translateY(20vh);
    } */
    @media only screen and (min-width: 1280px) {
        height: 200px;
        transform: translateY(0);
        top: auto;
        bottom: 0;
        background-color: #000;
        height: 266px;
        display: flex;
        justify-content: space-around;
    }

/*     @media only screen and (min-width: 800px) and (min-height: 360px) and (max-height: 428px) {
        height: 160px;
        transform: translateY(54vh);
    }
 */
/*     @media only screen and (max-height: 568px) {
      height: 345px;
      transform: translateY(38vh);
    }
    @media only screen and (min-height: 569px) and (max-height: 812px) {
      height: 450px;
      transform: translateY(55vh);
    } */

    >#search_button {
        max-width: 306px;
        min-width: 247px;
        font-family: 'montserrat-bold', sans-serif;
    }
}

#inventory_count {
    color: #fff;
    font-size: 1.4rem;
    font-weight: bold;
    margin: 4px 0px;
    @media only screen and (max-width: 767px) {
        font-size: 0.9rem;
    }
}

.form-input-filter {
    height: 31px;
    border: 1px solid #e2e5ed;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    box-shadow: inset 0 1px 2px 0 rgba(102,113,123,.21);
    font-size: 14px;
    display: flex;

    border: 0;
    box-shadow: none;
    background-color: transparent;

    @media screen and (min-width: 1024px) {
        height: 36px;
    }
}

.form-group-filter {
    @media screen and (min-width: 1024px) {
        height: 70px;
        color: #000;
    }
}
</style>
